// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CommentOutlinedSvg from "@fishx/icons-svg/es/asn/CommentOutlined";
import FishxIcon from '../components/FishxIcon';

var CommentOutlined = function CommentOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: CommentOutlinedSvg
  }));
};

CommentOutlined.displayName = 'CommentOutlined';
export default React.forwardRef(CommentOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/CommentOutlined.js
// module id = 2287
// module chunks = 0